import Transform from "@ember-data/serializer/transform";
import PredictorExplainer from "parog-web/models/predictor/predictor-explainer";

export default class PredictorExplainersTransform extends Transform {
  deserialize(serialized) {
    return (
      serialized?.map(
        item =>
          new PredictorExplainer(
            item["level"],
            item["explainer_type"],
            item["svg"],
            item["title"]
          )
      ) || []
    );
  }

  serialize(deserialized) {
    return (
      deserialized?.map(item => {
        return {
          level: item.level,
          explainer_type: item.explainerType,
          svg: item.svg,
          title: item.title
        };
      }) || []
    );
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "predictor-explainers": PredictorExplainersTransform;
  }
}
